/**
 * The build stamp shown at the bottom of the sidebar and on Settings
 * (2026-09-25, Michael: "can we add a build # to the bottom of the site for
 * revisions?").
 *
 * `number` is the commit count of the built revision: it only goes up, and
 * the same commit always carries the same number, so "build 1843" names one
 * exact state of the code. `sha` traces it to the commit; `branch` is what
 * the preview site shows, which is the whole reason it is there. A build
 * with no git (tests, a bare tree) reads "dev" — never a fabricated number.
 */
export interface BuildInfo {
  number: number;
  sha: string;
  branch: string;
  /** ISO timestamp of the build. */
  time: string;
}

export const BUILD: BuildInfo = typeof __BUILD_INFO__ !== 'undefined'
  ? __BUILD_INFO__
  : { number: 0, sha: 'dev', branch: '', time: '' };

/** "Build 1843 · 7f3a2c1" — or "Dev build" where there is no revision. */
export function buildLabel(info: BuildInfo = BUILD): string {
  if (!info.number || info.sha === 'dev') return 'Dev build';
  return `Build ${info.number} · ${info.sha}`;
}

/** The long form for a tooltip: branch and build time, when known. */
export function buildDetail(info: BuildInfo = BUILD): string {
  const parts: string[] = [];
  if (info.branch && info.branch !== 'HEAD' && info.branch !== 'master') parts.push(`branch ${info.branch}`);
  if (info.time) parts.push(`built ${new Date(info.time).toLocaleString()}`);
  return parts.join(' · ');
}
